import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_RT: TStep[] = [
  {
    pageId: PageId.SEX_RT_2_RTV2,
  },
  {
    pageId: PageId.DOG_AGE_RT_RTV2,
  },
  {
    pageId: PageId.URGE_RT_V1_RTV2,
  },
  {
    pageId: PageId.CHALLENGES_RT_RTV2,
  },
  {
    pageId: PageId.WALKS_FEEL_RTV2,
  },
  {
    pageId: PageId.DOG_EXCITEMENTS_TRIGGERS_RTV2,
  },
  {
    pageId: PageId.URGE_RT_5_RTV2,
  },
  {
    pageId: PageId.DOG_MISBEHAVES_RTV2,
  },
  {
    pageId: PageId.DOG_ACT_RT_RTV2,
  },
  {
    pageId: PageId.DOG_OFF_AT_HOME_RTV2,
  },
  {
    pageId: PageId.URGE_RT_6_RTV2,
  },
  {
    pageId: PageId.ACCESS_TO_FOOD_RTV2,
  },
  {
    pageId: PageId.URGE_RT_7_RTV2,
  },
  {
    pageId: PageId.DOG_AGGRESSIVE_RT_RTV2,
  },
  {
    pageId: PageId.DOG_CALM_DOWN_RT_RTV2,
  },
  {
    pageId: PageId.URGE_RT_8_RTV2,
  },
  {
    pageId: PageId.DOG_BREED_RT_RTV2,
  },
  {
    pageId: PageId.URGE_RT_9_RTV2,
  },
  {
    pageId: PageId.COMMANDS_61_RT_RTV2,
  },
  {
    pageId: PageId.COMMANDS_62_RT_RTV2,
  },
  {
    pageId: PageId.COMMANDS_63_RT_RTV2,
  },
  {
    pageId: PageId.URGE_RT_10_RTV2,
  },
  {
    pageId: PageId.URGE_LOADER_RT_RTV2,
  },
  {
    pageId: PageId.DOG_STATISTICS_RT_RTV2,
  },
  {
    pageId: PageId.TRAINING_RT_RTV2,
  },
  {
    pageId: PageId.PREPARE_FLOW_RT_RTV2,
  },
  {
    pageId: PageId.EMAIL_RT_RTV2,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_RTV2,
  },
  {
    pageId: PageId.URGE_RT_4_RTV2,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_RT_V2_RTV2,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_RT_RTV2,
  },
  {
    pageId: PageId.CHAT_UPSELL_RTV2,
  },
  {
    pageId: PageId.UPSELL_1_RTV2,
  },
  {
    pageId: PageId.UPSELL_PITPAT_RTV2,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
  {
    pageId: PageId.DOWNLOAD_RTV2,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_RT.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_RT.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
